import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';


function WidgetCheckbox({ state, setState, id, text, value = false, disabled = false, tips = "" }) {
  React.useEffect(() => {
    setState({
      id: id,
      value: value,
      error: false,
      errorMessage: null,
    });
  }, []);

  const handleChange = (e) => {
    setState((s) => ({ ...s, value: e.target.checked, error: false }));
  };


  return (
    <>
      {state !== null &&
        <FormControl error={state.error} className='w-full'>
          <FormControlLabel control={
            <Checkbox
              id={state.id}
              name={state.id}
              disabled={disabled}

              checked={state.value}
              onChange={handleChange}
            />}
            label={text}
          />
          <FormHelperText>
            {state.error && state.errorMessage}
            {state.error && state.errorMessage && <br />}
            {tips}
          </FormHelperText>
        </FormControl>
      }
    </>
  );
}

export default React.memo(WidgetCheckbox);